import React, { useEffect, useState, useContext } from "react";
import { DriverDetails, Drivertraninggiven, DriverDataPie } from "./Drivertraiingkpi";
import Piechart from "../../components/Graph/Piechart";
import { FilterContext } from "../../context/Filter";

const Driverindex = () => {
    const [piedata, setPieData] = useState({});
    const [driverdata, setDriverdata] = useState([]);
    const [trainingdata, setTrainingData] = useState([]);

    const { superArn: parArn, childArn } = useContext(FilterContext);
    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    const fetchpiedata = async () => {
        try {
            const data = await DriverDataPie(payload);
            setPieData(data);
        } catch (error) {
            console.error("Pie data fetch error:", error);
        }
    };

    const fetchDriverDetail = async () => {
        try {
            const data2 = await DriverDetails(payload);
            setDriverdata(data2);
        } catch (error) {
            console.error("Driver details fetch error:", error);
        }
    };

    const fetchdrivertraninggiven = async () => {
        try {
            const data3 = await Drivertraninggiven(payload);
            setTrainingData(data3);
        } catch (error) {
            console.error("Training data fetch error:", error);
        }
    };

    useEffect(() => {
        fetchDriverDetail();
        fetchdrivertraninggiven();
        fetchpiedata();
    }, []);

    return (
        <div>
            <div className=" block  justify-center justify-items-center ">
                <p className="bg-[#93C5FD] mt-1 rounded-sm p-1">Drivers Trained = {trainingdata?.result?.value}</p>
            </div>
            <Piechart data={piedata} />
        </div>
    );
};

export default Driverindex;
